import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Post } from '../AxiosFunctions';
import { BaseURL } from '../Config';
import { setPatientsHistoryQueue, setPatientsQueue } from '../Store/commonSlice';
import useApi from '../useApis';
const useClinic = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.authReducer);
  const doctorClinicId = userData?.clinicData?.[0]?.doctorClinicId ?? 0;
  const [patientMedicalInformation, setPatientMedicalInformation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState('');
  const [selectedData, setSelectedData] = useState(null);
  const [sessionData, setSessionData] = useState(null);
  const [opdDetails, setOpdDetails] = useState(null);
  const api = useApi();
  const getAllPatientsQueue = async () => {
    // setLoading(true);
    const response = await api?.getAllClinicPatientsQueue({
      doctorClinicId
    });
    if (response?.data?.headers?.code === 200) {
      dispatch(setPatientsQueue(response?.data?.body));
      setTotalCount(response?.data?.body?.pagination?.totalRowsCount);
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    // setLoading(false);
  };

  const deletePatientFromQueue = async (params, onSuccess) => {
    setLoading(true);
    const response = await api?.deletePatientfromQueue({
      ...params,
      doctorClinicId
    });

    if (response?.data?.headers?.code === 200) {
      if (typeof onSuccess === 'function') onSuccess();
      getAllPatientsQueue();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };

  const getPatientsDetails = async () => {
    setLoading(true);
    const response = await Post(BaseURL(''));
    if (response?.data?.headers?.code === 200) {
      // setSelectedData()
    } else {
      toast.error(response?.data?.headers?.msg);
    }
  };

  //today's session history
  const getPatientQueueChecked = async (params, onCancel) => {
    // setLoading(true);
    const response = await api?.getPatientQueueChecked(params);
    if (response?.data?.headers?.code === 200) {
      dispatch(setPatientsHistoryQueue(response?.data?.body));
      if (typeof onCancel === 'function') onCancel();
    } else {
      if (response?.data?.headers?.msg != 'No active session')
        toast.error(response?.data?.headers?.msg);
    }
    // setLoading(false);
  };
  const getSession = async (params) => {
    const response = await api?.getSession({
      ...params,
      doctorClinicId
    });
    if (response?.data?.headers?.code === 200) {
      setSessionData(response?.data?.body);

      return response?.data?.body;
    } else {
      if (response?.data?.headers?.msg != 'Active Session Not Found')
        toast.error(response?.data?.headers?.msg);
    }
  };

  const startSession = async () => {
    const response = await api.startSession();
    if (response?.data?.headers?.code === 200) {
      toast.success('Session started successfully');
      return true;
    } else {
      toast.error(response?.data?.headers?.msg);
    }
  };
  const endSession = async () => {
    const response = await api.sessionEnd();
    if (response?.data?.headers?.code === 200) {
      toast.success('Session closed successfully');
      return true;
    } else {
      toast.error(response?.data?.headers?.msg);
    }
  };

  const editPatientQueuFees = async (params, onCancel) => {
    setLoading(true);
    const response = await api.editPatientQueuFees(params);
    if (response?.data?.headers?.code === 200) {
      if (typeof onCancel === 'function') onCancel();
      toast.success('Patient Editional Fees Successfully');
    } else {
      toast.error(response?.data?.headers?.msg);
    }

    setLoading(false);
    return response;
  };

  const getOpdDetails = async (params) => {
    setLoading(true);
    const response = await api.getOpdDetails(params);
    if (response?.data?.headers?.code === 200) {
      setOpdDetails(response?.data?.body);
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const getPatientMedicalInformation = async (params) => {
    const response = await api.getPatientMedicalInformation(params);
    if (response?.data?.headers?.code === 200) {
      setPatientMedicalInformation(response?.data?.body);
    } else {
      toast.error(response?.data?.headers?.msg);
    }
  };
  const editCheckedPatient = async (params) => {
    const response = await api.editCheckedPatient(params);
    if (response?.data?.headers?.code === 200) {
      toast.success('Follow Up Added Successfully');
    } else {
      toast.error(response?.data?.headers?.msg);
    }
  };

  const editClinicFee = async (params, onSuccess) => {
    setLoading(true);
    const response = await api?.editClinicFee(params);
    if (response?.data?.headers?.code === 200) {
      toast.success('clinic Fee Added Successfully');
      if (typeof onSuccess === 'function') onSuccess();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  return {
    loading,
    totalCount,
    setPage,
    page,
    setSearch,
    search,
    getAllPatientsQueue,
    selectedData,
    getPatientsDetails,
    getPatientQueueChecked,
    deletePatientFromQueue,
    startSession,
    endSession,
    getSession,
    startSession,
    endSession,
    sessionData,
    editPatientQueuFees,
    getOpdDetails,
    opdDetails,
    getPatientMedicalInformation,
    patientMedicalInformation,
    setOpdDetails,
    editCheckedPatient,
    editClinicFee
  };
};

export default useClinic;
